import { Component, Input } from '@angular/core';

import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-worker-permissions',
  templateUrl: './worker-permissions.component.html',
  styleUrls: ['./worker-permissions.component.scss']
})
export class WorkerPermissionsComponent {

  @Input() worker: any;

  constructor(public okService: OkAloneService) { }

  statusBadgeColor(status: string): string {
    switch (status) {
      case 'granted':
        return 'success';
      case 'partial':
        return 'warning';
      case 'denied':
      case 'restricted':
        return 'danger';
      case 'not_determined':
        return 'info';
      case 'unavailable':
        return 'secondary';
      default:
        return 'secondary';
    }
  }

  hasPermissions(): boolean {
    return this.permissionRows().length > 0;
  }

  permissionRows(): any[] {
    const rows = this.worker?.permissions?.rows;
    if (!Array.isArray(rows)) {
      return [];
    }
    if (this.okService.hasFeature('motion_heartbeat')) {
      return rows;
    }
    return rows.filter((row: any) => row.key !== 'motion_fitness');
  }
}
